import styled from 'styled-components';

export const CenteredFlex = styled.div`
  display: flex;
  align-items: center;
`;
CenteredFlex.displayName = 'S.CenteredFlex';

export const CloseButton = styled.div`
  text-align: right;
  flex: 1 1 auto;
  padding-right: 20px;
`;
CloseButton.displayName = 'S.CloseButton';

export const BackButton = styled.div`
  text-align: left;
  padding-left: 20px;
`;

export const Header = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
  white-space: wrap;
  overflow: hidden;
  padding-left: 20px;
`;
Header.displayName = 'S.Header';
